(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-association', {
            parent: 'entity',
            url: '/type-association?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.typeAssociation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/type-association/type-associations.html',
                    controller: 'TypeAssociationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeAssociation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-association-detail', {
            parent: 'type-association',
            url: '/type-association/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.typeAssociation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/type-association/type-association-detail.html',
                    controller: 'TypeAssociationDetailController',
                    controllerAs: 'vm'

               }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeAssociation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeAssociation', function($stateParams, TypeAssociation) {
                    return TypeAssociation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'type-association',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('type-association-detail.edit', {
            parent: 'type-association-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type-association/type-association-dialog.html',
                    controller: 'TypeAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeAssociation', function(TypeAssociation) {
                            return TypeAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-association-test.new', {
            parent: 'type-association',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type-association/type-association-dialog.html',
                    controller: 'TypeAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-association', null, { reload: 'type-association' });
                }, function() {
                    $state.go('type-association');
                });
            }]
        })
        .state('type-association.edit', {
            parent: 'type-association',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type-association/type-association-dialog.html',
                    controller: 'TypeAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeAssociation', function(TypeAssociation) {
                            return TypeAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-association', null, { reload: 'type-association' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-association.delete', {
            parent: 'type-association',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type-association/type-association-delete-dialog.html',
                    controller: 'TypeAssociationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeAssociation', function(TypeAssociation) {
                            return TypeAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-association', null, { reload: 'type-association' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
